export default __webpack_public_path__ + "static/media/boostyourscore-valueprop.db1fdf28.svg";